import { Injectable } from '@angular/core';
import { RouterParamsService } from '../../shared/services/router-params.service';
import { Observable } from 'rxjs';
import { Allergy, PreviousAllergy } from '../models/previous-allergies';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PreviousAllergiesEntityService extends BaseEntityService<PreviousAllergy> {

  constructor(
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl, { singular: 'previousAllergy', plural: 'previousAllergies', url: 'previous-allergies' },
      routerParamsService
    );
    this.nameId = 'previousAllergyId';
  }

  createPreviousAllergy(
    allergy: Allergy,
    personId,
  ): Observable<PreviousAllergy> {
    const body: PreviousAllergy = {
      active: true,
      person: {
        id: personId,
      },
      allergy: {
        id: allergy.id,
      },
    };
    return this.add(body);
  }
}
